import React, { useState } from 'react';
import './FeedbackForm.css'; // Importing the CSS file

const FeedbackForm = () => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (rating <= 3) {
      // Construct mailto link for users with low ratings
      const subject = encodeURIComponent("דירוג שירות לקוחות");
      const body = encodeURIComponent(`הדירוג: ${rating}/5\nהמשוב: ${feedback}`);
      window.location.href = `mailto:Shimaajandawe31@gmail.com?subject=${subject}&body=${body}`;
    }
    // For rating > 3, you already have the logic to guide users to Google reviews
  };
  

  const handleCopyFeedback = () => {
    navigator.clipboard.writeText(feedback);
    alert('המשוב הועתק ללוח. אנא הדבק אותו בביקורות של Google.');
  };

  if (!submitted) {
    return (
        <form onSubmit={handleSubmit} className="feedback-form">
          <div className="rating-container">
            <p>האם אהבת את שירותינו? האם תמליץ עלינו?<br/>דרג את חווייתך.</p>
            <div className="stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <label key={star} className={`star ${rating >= star ? 'filled' : ''}`}>
                  <input
                    type="radio"
                    name="rating"
                    value={star}
                    onChange={() => setRating(star)}
                    className="star-radio"
                  />
                  ☆
                </label>
              ))}
            </div>
          </div>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="הזן את המשוב שלך כאן..."
            rows={4}
            className="feedback-textarea"
          />
          <button type="submit" className="submit-button">שלח משוב</button>
        </form>
      );
      } else {
      return (
        <div className="thank-you-message">
          {rating > 3 ? (
            <>
              <p>תודה על המשוב החיובי שלך! האם תוכל להקדיש רגע לשתף את הדירוג שלך בדף העסק שלנו ב-Google? זה יעזור לנו מאוד.</p>
              <div className='google-buttons'>
              <button onClick={handleCopyFeedback} className="copy-button">העתק דירוג</button>
              <a href="https://g.page/r/Ce7A9ALIf7OkEAI/review" target="_blank" rel="noopener noreferrer" className="google-link">השלם את הדירוג ב-Google</a>
              </div>
            </>
          ) : (
            <p>תודה על המשוב והכנות שלך איתנו. אנחנו נעבוד קשה על לשפר ולהתפתח.</p>
          )}
        </div>
      );
      }
    };      

export default FeedbackForm;
